import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { Helmet } from "react-helmet";

import { Surface } from "Cobalt/Surface";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";

type Props = {
  title?: string;
  className?: string;
  children: React.ReactNode;
} & JSX.LibraryManagedAttributes<typeof Grid, React.ComponentProps<typeof Grid>> &
  JSX.LibraryManagedAttributes<typeof Card, React.ComponentProps<typeof Card>>;

const Page = ({ className, children, title, ...rest }: Props) => (
  <Div className="min-h-dvh">
    <Grid
      className={classnames(className, {
        EmployeeApplicationPage: !isIntuit(),
      })}
      {...rest}
    >
      <Surface p={0}>
        {title && (
          <Helmet>
            <title>{title}</title>
          </Helmet>
        )}

        {children}
      </Surface>
    </Grid>
  </Div>
);

export default Page;
